import React, { Component } from 'react';
import { connect } from 'react-redux';
import QueryString from 'query-string';
import _ from "underscore";
import format from 'format-util';

import TransactionDetailsFilterPanel from './FilterPanel';
import SearchResultsForm from './SearchResultsForm';
import ConfirmAction from './ConfirmAction';
import LanguageStringResolver from '../fields/language/LanguageStringResolver';
import TRANSACTIONS_CONTROLLER from '../../controllers/transactions';
import GLOBAL_FILTER_CONTROLLER from '../../controllers/globalFilter';
import TRANSACTION_EDIT_CONTROLLER from '../../controllers/transactionEdit';
import ApplicationMessages from '../inAppMessages/ApplicationMessages';
import ComponentUtil from '../../utils/componentUtil';
import Logger, {LOG_LEVELS, ALL_MESSAGES} from '../../utils/logger';
import {FIELDS as GLOBAL_FILTER_PANEL_FIELDS} from '../filter/GlobalFilterPanel';
import ApplicationMessageWithDetail from '../inAppMessages/ApplicationMessageWithDetail';

const PAGE_INTERNAL_IDS = [
  GLOBAL_FILTER_PANEL_FIELDS.PARAM_COMPANY_ID,
  GLOBAL_FILTER_PANEL_FIELDS.PARAM_COUNTRY_CODE,
  "companyID"
];

const log = new Logger('TRANSACTION_SEARCH_PAGE', LOG_LEVELS.DEBUG);

// For anything that is unset in the browser URL
const browserUrlQueryParams = {
  searchType: '0', // search by invoice number
};

// For anything that is unset before passing to the controller
const requestDefaultFilterParams = Object.assign({}, {
  searchType: '1', // search by document ID
  reference: '-1', // Non-existent document ID
  companyID: '-1', // All companyIds
  year: '0', // All years
});

function setDefaultParams(original, defaults) {
  const values = Object.assign({}, original);
  let changed = false;
  for (let fieldName in defaults) {
    if (typeof values[fieldName] !== 'string' || values[fieldName] === '') {
      values[fieldName] = defaults[fieldName];
      changed = true;
    }
  }
  
  //Force exact match to be true if search type is document ID.
  if (values.searchType === '1' && values.exactMatch !== '1') {
    values.exactMatch = '1';
    changed = true;
  }

  return {changed, values};
}

function parseQueryParams(string) {
  const originalQp =  QueryString.parse(string, {arrayFormat: 'index'});
  return _.each(originalQp, (value, key) => {return decodeURIComponent(value)});
}

function stringifyQueryParams(qp) {
  const encodedQp = _.each(qp, (value, key) => {return encodeURIComponent(value)});
  return QueryString.stringify(encodedQp, {arrayFormat: 'index'});
}

class TransactionSearchPage extends Component {


  clearErrorMessages() {
    log.clearAllDictionaryErrors();
    log.debug('clearAllDictionaryErrors: ');
  }

  constructor(props) {
    super(props);
    this.state = {
        confirmAction: undefined,
        loading: true,
        isTabToggle : true,
        resetAllActionToDefault: false,
        errorDetails: []
    };
    this.docsPerPage = 15;
    this.doResetPaging = 0;
  }
  
  doSearch(selection) {
    log.debug('doSearch: ', selection);
    ComponentUtil.updateUrlParams(this.props.location, this.props.history, selection, {
      disableMonthYearSpecialValues: true
    });
    this.props.doSearchTransactions(selection);
  }

  doSearchIDsAndFirstPage(selection) {
    this.doResetPaging = 1;
    log.debug('doSearchIDsAndFirstPage: selection: ', selection);
    this.props.doSearchTransactionIDsAndFirstPage(selection, this.docsPerPage);
    let urlsParams = Object.assign({}, selection);
    PAGE_INTERNAL_IDS.forEach(key => delete urlsParams[key]);
    ComponentUtil.updateUrlParams(this.props.location, this.props.history, urlsParams, {
      disableMonthYearSpecialValues: true
    });
    this.clearErrorMessages();
  }

  doSearchPage(transactionIDs, startIndex, docsPerPage) {
    log.debug('doSearchPage: ', transactionIDs);
    this.props.doSearchTransactionPage(transactionIDs, startIndex, docsPerPage);
  }

  filterSelectionHandler(keyValuePairs) {
    log.debug('filterSelectionHandler - KeyValuePairs: ', keyValuePairs);
    const parsedQueryParams = parseQueryParams(this.props.location.search);
    log.debug('filterSelectionHandler - parsedQueryParams: ', parsedQueryParams);
    const newQueryParams = Object.assign({}, parsedQueryParams, keyValuePairs); // SVR-660

    log.debug('filterSelectionHandler - newQueryParams:', newQueryParams);
    this.props.history.push({
      search: stringifyQueryParams(newQueryParams)
    });
  }

  doConfirmRequestedAction(action, transactionIds) {
    log.debug('doConfirmRequestedAction(): ', action, transactionIds);
    if (!Array.isArray(transactionIds) || transactionIds.length <= 0) {
      log.warn('doConfirmRequestedAction: no transactionIds', transactionIds);
      return;
    }
    if(_.isEmpty(action)) {
      this.setState({confirmAction: undefined, resetAllActionToDefault: false });
      return;
    }

    // Call TransactionDetail/$id/edit?action=$action to get the treeview editor - ux same for redeliver & force2error
    if (['forceToError', 'redeliver'].indexOf(action) >=0 && transactionIds.length === 1) {
      log.debug('doConfirmRequestedAction %s', transactionIds.length );
      this.props.history.push({
        pathname: format('/TransactionDetail/%s/edit', transactionIds[0]),
        search: '?action='+action,
      });
      this.setState({resetAllActionToDefault: false });
      return;
    }
    const confirmAction = {action, ids: transactionIds, transactions: this.props.transactionPage.filter((transaction) => {return transactionIds.indexOf(transaction.id) >= 0;})};
    log.debug('doConfirmRequestedAction(): confirmAction ', confirmAction);
    this.setState({confirmAction, resetAllActionToDefault: false });
  }

  doActionConfirmed(confirmedAction, username, comment) {
    log.debug('doActionConfirmed(): ', confirmedAction, username, comment);
    this.setState({
      errorDetails: []
    });
    this.props.doTransactionAction(confirmedAction.action, confirmedAction.ids, comment, (error, response) => {
      this.setState({resetAllActionToDefault: false });
      log.debug('doActionConfirmed().callback: ', error, response);
      if (error) {
        let errors =_.isEmpty(error.errorData) ? [] : Array.isArray(error.errorData) ? error.errorData: [error.errorData];
        errors =  errors.map( ( e ) => {
          return {
              id:  e.invoiceNumber ? `${e.invoiceNumber}`.replace(/\'/g,"") : (e.transactionId ? e.transactionId : ""),
              message: `${e.failure}`
          };
        });
        this.setState({
          errorDetails: errors
        });
        log.debug('doActionConfirmed().callback: ERROR performing %s on %j: ', confirmedAction.action, confirmedAction.ids);
        return;
      }
      this.doResetPaging = 1;
      let globalFilterSelection = GLOBAL_FILTER_CONTROLLER.getAll();
      let parsedQueryParams = Object.assign({}, globalFilterSelection, parseQueryParams(this.props.location.search));
      this.props.doSearchTransactionIDsAndFirstPage(parsedQueryParams, this.docsPerPage);
    });
    this.setState({confirmAction: undefined, resetAllActionToDefault: true });
  }
  
  doClearRequestedAction() {
    log.debug('doClearRequestedAction(): ');
    this.setState({confirmAction: undefined, resetAllActionToDefault: true, errorDetails: [] });
  }

  render() {
    let globalFilterSelection = GLOBAL_FILTER_CONTROLLER.getAll();
    let parsedQueryParams = Object.assign({}, globalFilterSelection, parseQueryParams(this.props.location.search));
    log.debug('render - json data: ', this.props.transactionPage);
    log.debug('render - parsedQueryParams: ', parsedQueryParams);
    log.debug('all props: ', this.props);
    let resetPaging = 0;
    if (this.doResetPaging === 1) {
      this.doResetPaging = 0;
      resetPaging = 1;
    }
    return (
      <div className="content-area">
        <s-container>
          {
            this.state.errorDetails && this.state.errorDetails.length > 0 ?
            (
              <ApplicationMessageWithDetail  
                messageIds={[ ALL_MESSAGES.TRANSACTION_ACTION_ERROR ]} 
                messageType="applicationError"
                messageDetails={this.state.errorDetails || []}
                titleLanguageString='transactions_ActionErrorDetails'
              />
            ) :
            (
              <ApplicationMessages messageType="applicationError"/>
            )
          }
          <ApplicationMessages messageType="applicationWarning"/>
          <ApplicationMessages messageIds={[ALL_MESSAGES.TRANSACTION_ACTION_SUCCESS]} messageType="applicationSuccess"/>
          <h1><LanguageStringResolver string="transactionSearchResults_Title"/></h1>

          <TransactionDetailsFilterPanel
            doSearchIDsAndFirstPage={this.doSearchIDsAndFirstPage.bind(this)}
            filterOptions={parsedQueryParams}
          />

            {
              (this.props.transactionPage)  ?
                (<SearchResultsForm
                  transactionIDs = {this.props.transactionIDs}
                  transactionPage = {this.props.transactionPage}
                  docsPerPage = {this.docsPerPage}
                  doResetPaging = {resetPaging}
                  doSearchPage = {this.doSearchPage.bind(this)}
                  onRequestAction={this.doConfirmRequestedAction.bind(this)}    
                  resetAllActionToDefault={this.state.resetAllActionToDefault}             
                />) :
                (<div></div>)
            }
            {
              this.state.confirmAction ? (
                <ConfirmAction
                  action={this.state.confirmAction.action}
                  title={'transactionSearchActionConfirmationTitle_'+this.state.confirmAction.action}
                  list={this.state.confirmAction.transactions}
                  onCancel={this.doClearRequestedAction.bind(this)}
                  onConfirmed={this.doActionConfirmed.bind(this, this.state.confirmAction)}
                />)
              : (<div></div>)
            }
        </s-container>
        <div className="clear"></div>

      </div>
    );
  }

  componentWillUnmount() {
    this.props.doClearErrors();
  }

  componentDidMount() {
    log.debug('componentDidMount()');
    this.clearErrorMessages();
    let parsedQueryParams = QueryString.parse(this.props.location.search) || {};
    log.debug('componentDidMount(): queryParams', parsedQueryParams);
    let globalFilterValues = GLOBAL_FILTER_CONTROLLER.getAll();
    log.debug('componentDidMount(): globalFilterValues', globalFilterValues);
    let filterSelection = Object.assign({}, parsedQueryParams, globalFilterValues);
    log.debug('componentDidMount(): defaulting query parameters to :', filterSelection);
    let adaptedFilterSelection = setDefaultParams(filterSelection, browserUrlQueryParams) || {};
    let urlParams = Object.assign({}, adaptedFilterSelection.values);
    PAGE_INTERNAL_IDS.forEach(key => delete urlParams[key]);
    ComponentUtil.updateUrlParams(this.props.location, this.props.history, urlParams, {
      disableMonthYearSpecialValues: true
    });   
    // Only load if reference is set. Otherwise, we a trying to load everything.     
    // TODO: We will not support urls with exactMatch = 0 to load data during mount phase.
    // URL is only passing companyCode will fail to load data as companyId is only available during component update cycle,
    // Because its a redux state data. Need to confirm if this behavior is ok?
    if (adaptedFilterSelection.values && adaptedFilterSelection.values.reference)  {
        this.doResetPaging = 1;
        this.props.doSearchTransactionIDsAndFirstPage(adaptedFilterSelection.values, this.docsPerPage);
    } else {
        this.props.doResetSearchIDsAndPage();
    }
  }
}

function mapStateToProps(state) {
  log.debug('mapStateToProps: ', state);
  return {
    transactionIDs: (state.transactionSearch && state.transactionSearch.transactionIDs) || [],
    transactionPage: (state.transactionSearch && state.transactionSearch.transactionPage) || []
  };
}

function mapDispatchersToProps(dispatch) {
  return {
    doSearchTransactionIDsAndFirstPage: (filterParams, docsPerPage) => {      
      log.debug('doSearchTransactionIDsAndFirstPage: ', filterParams);
      //Clear existing result
      dispatch(TRANSACTIONS_CONTROLLER.resetSearchIDsAndPage());
      filterParams.companyID = filterParams.companyId+'';
      const {changed, values} = setDefaultParams(filterParams, requestDefaultFilterParams, true);
      const apiParams = {
        Reference: values.reference,
        CompanyID: values.companyID,
        Year: values.year,
        ExactMatch: values.exactMatch,
        SearchType: values.searchType
      };
      dispatch(TRANSACTIONS_CONTROLLER.doSearchIDsAndFirstPage(apiParams, docsPerPage));
    },
    doSearchTransactionPage: (transactionIDs, startIndex, docsPerPage) => {
      log.debug('doSearchTransactionPage: ', transactionIDs);      
      dispatch(TRANSACTION_EDIT_CONTROLLER.doClearErrors());
      dispatch(TRANSACTIONS_CONTROLLER.doSearchPage(transactionIDs, startIndex, docsPerPage));
    },
    doResetSearchIDsAndPage: () => {
      dispatch(TRANSACTIONS_CONTROLLER.resetSearchIDsAndPage());
    },
    doTransactionAction: (action, ids, reason, cb) => {
      log.debug('doTransactionAction: ', action, ids, reason);
      dispatch(TRANSACTION_EDIT_CONTROLLER.doClearErrors());
      // Export follows a different logic to the other actions, so call a different function in the controller
      if (action === 'export') {
        dispatch(TRANSACTIONS_CONTROLLER.saveTransactionXMLMultiple(ids))
      } else {
        dispatch(TRANSACTIONS_CONTROLLER.doAction(action, ids, reason, cb));
      }
    },
    doClearErrors: () =>{
      dispatch(TRANSACTION_EDIT_CONTROLLER.doClearErrors());
    }
  }
}

export default connect(mapStateToProps, mapDispatchersToProps)(TransactionSearchPage);